import {Editor, Transforms, Node} from 'slate';
import {CONTENT_ELEMENT_TYPES} from '../constants';

function makeSureOrderedListsAreOrdered (editor, [entryNode, entryNodePath]) {
  if (!editor.selection) {
    return false;
  }

  const shouldNormalizeTopLevelContent = entryNodePath.length === 0 && (
    editor.selection.anchor.path.length === 0 ||
    Node.get(editor, editor.selection.anchor.path.slice(0, 1)).type !== 'process'
  );

  const shouldNormalizeProcessStepContent = CONTENT_ELEMENT_TYPES.includes(entryNode.type);

  if (
    !shouldNormalizeTopLevelContent &&
    !shouldNormalizeProcessStepContent
  ) {
    return false;
  }

  return normalizeOrderedListItems(editor, [entryNode, entryNodePath]);
}

function normalizeOrderedListItems (editor, [entryNode, entryNodePath]) {
  let hasMadeUpdates = false;

  // All adjacent orderedlistitems should have sequential numbers
  // TODO: Review performance on slow machines
  let prevNode = {};

  // Tracks the last *computed* number at each indent level. This allows us to:
  // - Resume numbering after other non-list element
  // - Correctly renumber from 1 when the first item is deleted
  const prevComputedNumberAtIndent = {
    0: null,
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
    7: null,
    8: null,
  };

  Editor.withoutNormalizing(editor, () => {
    for (let i = 0; i < entryNode.children.length; i++) {
      const node = entryNode.children[i];
      const nodeIndent = node.indent || 0;
      const prevNodeIndent = prevNode.indent || 0;

      const oldNumber = node.number;
      let newNumber = node.number;

      if (node.type === 'ordered-list-item') {
        if (prevNodeIndent < nodeIndent && nodeIndent > 0) {
          // Increasing indent: start a new sub-list at 1
          newNumber = 1;
        }
        else if (prevNodeIndent > nodeIndent && nodeIndent > 0) {
          // Returning from a deeper indent: resume from the last number at
          // this level (or start at 1 if none seen yet)
          newNumber = (prevComputedNumberAtIndent[nodeIndent] ?? 0) + 1;
        }
        else if (prevComputedNumberAtIndent[nodeIndent] !== null) {
          // Continue the sequence — works both for direct continuation and for
          // resuming after a non-list element (e.g. a screenshot)
          newNumber = prevComputedNumberAtIndent[nodeIndent] + 1;
        }
        else {
          // No ordered-list-item has been seen at this indent yet: start at 1.
          // This handles the case where the first item in a list is deleted.
          newNumber = 1;
        }

        if (newNumber !== oldNumber) {
          Transforms.setNodes(editor, {
            number: newNumber,
          }, {
            at: [...entryNodePath, i],
          });

          hasMadeUpdates = true;
        }

        prevComputedNumberAtIndent[nodeIndent] = newNumber;
      }

      prevNode = node;
    }
  });
  return hasMadeUpdates;
}

export default makeSureOrderedListsAreOrdered;
